export default __webpack_public_path__ + "static/media/Violaine.241bbe47.jpg";